import { left_arrow_icon, right_arrow_icon } from 'src/assets'
import { button_t, dict } from 'src/types'

const make_flavors = (base: 'primary' | 'accent' | 'grey'): dict<button_t> => ({
  [base]: {
    classes: base,
  },
  [`${base}_flip`]: {
    classes: `${base}-flip`,
  },
  [`${base}_flip_border`]: {
    classes: `${base}-flip-border`,
  },
  [`${base}_back`]: {
    classes: base,
    classes_iconl: 'filter-white',
    iconl: left_arrow_icon,
  },
  [`${base}_next`]: {
    classes: base,
    classes_iconr: 'filter-white',
    iconr: right_arrow_icon,
  },
  [`${base}_flip_back`]: {
    classes: `${base}-flip`,
    classes_iconl: `filter-${base}`,
    iconl: left_arrow_icon,
  },
  [`${base}_flip_next`]: {
    classes: `${base}-flip`,
    classes_iconr: `filter-${base}`,
    iconr: right_arrow_icon,
  },
  [`${base}_flip_back_border`]: {
    classes: `${base}-flip-border`,
    classes_iconl: `filter-${base}`,
    iconl: left_arrow_icon,
  },
  [`${base}_flip_next_border`]: {
    classes: `${base}-flip-border`,
    classes_iconr: `filter-${base}`,
    iconr: right_arrow_icon,
  },
  [`transparent_${base}`]: {
    classes: `transparent-${base}`,
  },
  [`transparent_${base}_back`]: {
    classes: `transparent-${base}`,
    classes_iconl: `filter-${base}`,
    iconl: left_arrow_icon,
  },
  [`transparent_${base}_next`]: {
    classes: `transparent-${base}`,
    classes_iconr: `filter-${base}`,
    iconr: right_arrow_icon,
  },
})

export const flavors: dict<button_t> = {
  ...make_flavors('primary'),
  ...make_flavors('accent'),
  ...make_flavors('grey'),

  transparent_white: {
    classes: 'transparent-white',
  },
  transparent_white_border: {
    classes: 'transparent-white-border',
  },
  transparent_dark: {
    classes: 'transparent-dark',
  },
}
